/**
 *
 * common.js
 *
 *
 */
(() => {


	/**
	 *
	 *
	 * Variable
	 *
	 *
	 */
	/**************************************************************
	 * global
	**************************************************************/
	const root = document.body.dataset.root;
	// const mqUpLg = getComputedStyle(document.documentElement).getPropertyValue('--mqUp-lg');
	const mqDownLg = getComputedStyle(document.documentElement).getPropertyValue('--mqDown-lg');




	/**
	 *
	 * Svg
	 *
	 * imgタグなどからSVGを生成。
	 * common.cssに属するクラスは全てここで一括指定。
	 * ページ固有のものはimgタグやdata属性で直接指定。
	 *
	 */
	window.addEventListener('DOMContentLoaded', () => {
		/**************************************************************
		 * 直接指定
		**************************************************************/
		new changeSvg('img.js-svg',{});
		new changeSvg('[data-class="js-svg"]',{});


		/**************************************************************
		 * 一括指定
		**************************************************************/
		new changeSvg('.p-card__joining',{
			svg: root + 'assets/img/common/icon/card_line.svg',
		});

		new changeSvg('.c-arrow,.c-arrow2,.c-arrow3',{
			svg: root + 'assets/img/common/icon/arrow.svg',
		});
		new changeSvg('.c-down',{
			svg: root + 'assets/img/common/icon/down.svg',
		});
		new changeSvg('.c-up',{
			svg: root + 'assets/img/common/icon/up.svg',
		});
		new changeSvg('.c-blank,.c-blank2',{
			svg: root + 'assets/img/common/icon/blank.svg',
		});

		new changeSvg('.c-title__icon',{
			svg: root + 'assets/img/common/icon/title_line.svg',
		});
		new changeSvg('.c-num',{
			svg: root + 'assets/img/common/icon/num_line.svg',
		});
		new changeSvg('.c-scroll__icon',{
			svg: root + 'assets/img/common/icon/scroll.svg',
		});

		new changeSvg('.c-sns-x',{
			svg: root + 'assets/img/common/icon/sns_x.svg',
		});
		new changeSvg('.c-sns-line',{
			svg: root + 'assets/img/common/icon/sns_line.svg',
		});
		new changeSvg('.c-sns-instagram',{
			svg: root + 'assets/img/common/icon/sns_instagram.svg',
		});

		new changeSvg('.c-receiver',{
			svg: root + 'assets/img/common/icon/receiver.svg',
		});


	});







	/**
	 *
	 *
	 * Base
	 *
	 *
	 */
	/**************************************************************
	 * lenis
	************************************************************ */
	// if( window.matchMedia('(hover: hover)').matches ){
	// 	window.lenis = new Lenis({
	// 		lerp           : 0.2,
	// 		wheelMultiplier: .85,
	// 		smooth         : true,
	// 		smoothTouch    : false,
	// 		syncTouch      : false,
	// 		easing         : function(x){
	// 			return 1 - Math.pow(1 - x, 3);
	// 		},
	// 	});

	// 	/******************************************
	// 	 * resize
	// 	 ******************************************/
	// 	let lastScrollHeight = 0;
	// 	let resizeRafId      = 0;
	// 	let lastCheckTime    = 0;

	// 	function requestLenisResize(){
	// 		if( resizeRafId ){ return; }

	// 		resizeRafId = requestAnimationFrame(function(){
	// 			resizeRafId = 0;

	// 			const scrollHeight = document.documentElement.scrollHeight;

	// 			if( scrollHeight !== lastScrollHeight ){
	// 				lastScrollHeight = scrollHeight;
	// 				window.lenis.resize();
	// 			}
	// 		});
	// 	}

	// 	function onScrollNeedResize(){
	// 		const now = performance.now();
	// 		if( now - lastCheckTime < 200 ){ return; }
	// 		lastCheckTime = now;

	// 		requestLenisResize();
	// 	}

	// 	lastScrollHeight = document.documentElement.scrollHeight;
	// 	window.lenis.resize();

	// 	if( typeof window.lenis.on === 'function' ){
	// 		window.lenis.on('scroll', onScrollNeedResize);
	// 	}else{
	// 		window.addEventListener('scroll', onScrollNeedResize, { passive: true });
	// 	}

	// 	/******************************************
	// 	 * raf
	// 	 ******************************************/
	// 	function raf(time){
	// 		window.lenis.raf(time);
	// 		requestAnimationFrame(raf);
	// 	}
	// 	requestAnimationFrame(raf);

	// 	window.addEventListener('load', function(){
	// 		requestLenisResize();
	// 	});

	// 	if( document.fonts && document.fonts.ready ){
	// 		document.fonts.ready.then(function(){
	// 			requestLenisResize();
	// 		});
	// 	}
	// }


	/**************************************************************
	 * cssVariable
	**************************************************************/
	new cssVariable(null,{
		// vh: true,
		vw: true,
	});



	/**************************************************************
	 * useragent
	**************************************************************/
	new uaLite({
		device    : true,
		deviceType: true,
		browser   : true,
		display   : true,
	});


	/**************************************************************
	 * addClass
	**************************************************************/
	window.addEventListener('load',function(){
		document.body.classList.add('is-load');
	});


	/**************************************************************
	 * smoothScroll
	**************************************************************/
	const easingFuncs = new getEasing({
		easing: 'easeInOutExpo',
	});

	new smoothScroll('a[href^="#"]',{
		documentTop   : true,
		easingFunction: easingFuncs,
		minus         : [0],
		speed         : 800,
	});






	/**
	 *
	 *
	 * Layout
	 *
	 *
	 */
	/**************************************************************
	 * headerLogoColor
	 * common/layout_headerLogoColor.js
	**************************************************************/

	/**************************************************************
	 * headerSticky
	 * common/layout_headerSticky.js
	**************************************************************/

	/**************************************************************
	 * popup
	**************************************************************/
	new popup('.l-header__button,.home-kv__button',{
		popupSelector  : '.l-sitemap',
		bg             : false,
		smoothScroll   :'a[href^="#"]',
		popupOpenClass : 'is-open',
		buttonOpenClass: 'is-open',
		bodyOpenClass  : 'is-sitemap-open',
		basicId        : 'aria-sitemap',
		basicIdIndex   : false,
	});








	/**
	 *
	 *
	 * UI
	 *
	 *
	 */
	/**************************************************************
	 * loopSlider
	**************************************************************/
	imagesLoaded( document.querySelectorAll('.js-loopslider img,.js-loopslider-mqUp-lg img'), function( instance ) {
		new loopSlider( '.js-loopslider:not(.-column),.js-loopslider-mqUp-lg:not(.-column)', {
			mediaQuery    : null,
			sliderSelector: '.js-loopslider__content',
			resizeDelay   : 0,
			type          : 'horizontal',
			clone         : 5,
			speed         : 0.5,
			// speed         : 2,
			addSize       : 10,
		});

		new loopSlider( '.js-loopslider.-column', {
			mediaQuery    : null,
			sliderSelector: '.js-loopslider__content',
			resizeDelay   : 0,
			type          : 'vertical',
			clone         : 5,
			speed         : 0.5,
			// speed         : 2,
			addSize       : 10,
		});
	});

	/**************************************************************
	 * intervalChange
	**************************************************************/
	window.addEventListener('load',() => {
		const target = document.querySelectorAll('.js-slider');

		for ( let i = 0; i < target.length; i++ ){
			const sliderEl   = target[i];
			const counterEl  = sliderEl.querySelector('.js-slider__counter');
			const hasCounter = !!counterEl;

			const hasDots = sliderEl.classList.contains('-dots');

			new intervalChange(sliderEl, {
				sliderSelector          : '.js-slider__content',
				autoplay                : true,
				immedStart              : true,
				intervalSpeed           : 5000,
				startDelay              : 0,
				put                     : false,
				dots                    : hasDots,
				dotsInnerHTML           : '<button type="button"></button>',
				zIndex                  : false,
				navigation              : false,
				addData                 : false,

				counter                 : hasCounter,
				counterClick            : hasCounter,
				counterContainerSelector: '.js-slider__counter',

				dotsClass               : ['c-dots2','spotlight-mc__figure__dots'],
			});
		}
	})


	/**************************************************************
	 * modal
	**************************************************************/
	if( document.querySelector('.js-modal-img') ){
		new modal('body',{
			mediaQuery             : null,
			type                   : 'img',
			bg                     : true,
			bgPosition             : 'inner',
			buttonSelector         : '.js-modal-img',
			closePosition          : 'navCenter',
			timeout                : 700,
			wrapper                : 'body',
			modalId                : 'modal-img',

			modalClasss            : ['js-modal'],
			modalInnerClasss       : ['js-modal__inner'],
			closeClasss            : ['js-modal__close'],
			bgClasss               : ['c-overlay'],

			figureClasss           : ['js-modal__figure'],
			captionClasss          : ['js-modal__caption'],
			imgClasss              : ['js-modal__img'],

			closeInnerHTML         : '<button aria-label="閉じる"><span></span><span></span></button>',
			navigationPrevInnerHTML: '<button aria-label="前へ"><i class="c-arrow3 -regular -white-black u-reverse"></i></button>',
			navigationNextInnerHTML: '<button aria-label="次へ"><i class="c-arrow3 -regular -white-black"></i></button>',
			openClass              : 'is-modal-open',
		});
	}


	/**************************************************************
	 * cursor
	**************************************************************/
	if( document.querySelector('.p-contents') ){
		new cursor({
			cursorClass    : ['js-cursor'],
			firstClass     : ['p-contents__txt','c-radius-2xs2','c-txt-rg','c-crop','-people'],
			firstSpeed     : 0.15,
			firstInnerHTML : '<p>配電工は、かっこいい！でも実は、特別じゃない、ふつうの人。「チーム音更」は、みんなが主役。</p><i class="c-arrow2 -regular"></i>',
			secondClass     : ['p-contents__txt','c-radius-2xs2','c-txt-rg','c-crop','-company'],
			secondSpeed     : 0.15,
			secondInnerHTML : '<p>20代の若手から70代のベテランまで、世代を超えた配電工が、広い十勝の空の下、力を合わせて灯りをつないでいます。</p><i class="c-arrow2 -regular"></i>',
			addStyle       : true,
			zindexBase     : 2147483648, // 最大値 + 1
			hovers :[
				['.p-contents a[href*="people"]','is-people'],
				['.p-contents a[href*="company"]','is-company'],
			],
		});

		new cursor({
			cursorClass   : ['js-cursor'],
			firstClass    : ['p-contents__txt','c-radius-2xs2','c-txt-rg','c-crop','-work'],
			firstSpeed    : 0.15,
			firstInnerHTML: '<p>変電所からの電気を家庭へと届ける役割を担い、電柱や電線の新設・保守・整備を行っています。</p><i class="c-arrow2 -regular"></i>',
			addStyle      : true,
			zindexBase    : 2147483648, // 最大値 + 1
			hovers :[
				['.p-contents a[href*="work"]','is-work'],
			],
		});
	}

	if( document.querySelector('.l-spotlight') ){
		new cursor({
			cursorClass   : ['js-cursor'],
			firstClass    : ['js-cursor__view','c-view'],
			firstSpeed    : 0.15,
			firstInnerHTML: 'View more',
			addStyle      : true,
			zindexBase    : 2147483648, // 最大値 + 1
			position      : '.l-spotlight a',
			hovers :[
				['.l-spotlight a','is-view'],
			],
		});
	}


	/**************************************************************
	 * accordion
	 * hoverとclickで親要素のクラスを変えて振り分ける
	 * 小要素のクラスは同じ
	 * スタイルは各々で指定する
	**************************************************************/
	new accordion('.js-accordion-click-mqDown-lg',{
		mediaQuery         : 'screen and ( max-width: '+ mqDownLg +'px )',
		transitionDuration : 500,
		addHeight          : true,
		switchSelector     : '.js-accordion__switch',
		closeSwitchSelector: null,
		panelSelector      : '.js-accordion__panel',
		event              : 'click',
		anotherElementClose: false,
		openClass          : 'is-open',
		firstOpenClass     : 'is-first',
		basicId            : 'aria-accordion-',
		onInit : null,
		onOpen : null,
		onClose: null,
	});

	new accordion('.js-accordion-hover',{
		transitionDuration : 500,
		addHeight          : false,
		switchSelector     : '.js-accordion__switch',
		closeSwitchSelector: '.js-accordion__close',
		panelSelector      : '.js-accordion__panel',
		event              : 'hover',
		anotherElementClose: false,
		openClass          : 'is-open',
		firstOpenClass     : 'is-first',
		basicId            : 'aria-accordion-',
		onInit             : null,
		onOpen             : null,
		onClose            : null,
	});


	/**************************************************************
	 * hoverChase
	**************************************************************/
	if( window.matchMedia('(hover: hover)').matches ){
		new hoverChase( '.js-chase', {
			addClass      : 'is-chase',
			amount        : .4,
			moveSpeed     : .16,
			moveEasing    : Power1.easeOut,
			leaveEpeed    : .65,
			leaveEasing   : Elastic.easeOut.config(1, 0.3),
			slope         : .05,
			getSizeEvent  : ['DOMContentLoaded','load','resize'],
			getOffsetEvent: ['load','resize','scroll','sitemapScrolling'],
		});
	}










	/**
	 *
	 *
	 * Effect
	 *
	 *
	 */
	/**************************************************************
	 * parallax
	**************************************************************/
	if( !document.body.classList.contains('ua-safari') ){
		new parallax('.js-parallax-img',{
			mediaQuery: null,
			direction : 'vertical',
			move      : -.08,
			speed     : 1,
			standard  : .5,
			centerMode: true,
			IntersectionObserverOptions: {
				rootMargin: '50px 0px'
			},
		});

		new parallax('.js-parallax.-small',{
			direction    : 'vertical',
			move         : .2,
			speed        : 1,
			standard     : .5,
			centerMode   : true,
		});
		new parallax('.js-parallax.-medium',{
			direction    : 'vertical',
			move         : .15,
			speed        : 1,
			standard     : .5,
			centerMode   : true,
		});
		new parallax('.js-parallax.-large',{
			direction    : 'vertical',
			move         : .1,
			speed        : 1,
			standard     : .5,
			centerMode   : true,
		});
	}


	/**************************************************************
	 * scrollClass
	**************************************************************/
	window.addEventListener('load', () => {
		const target = document.querySelectorAll('header[class*="p-hero"],.js-load-trigger');

		for (let i = 0; i < target.length; i++) {
			target[i].classList.add('is-shown');
		}
	});


	new scrollClass('.js-trigger',{
		addClass: 'is-shown',
		IntersectionObserverOptions: {
			rootMargin: '-20% 0px -20%', // 5
		},
	});




})();
